/**
 * Created by tdunham on 6/27/2017.
 */

import { Injectable }                       from '@angular/core';
import { Resolve }                          from '@angular/router';

import { Sport }                            from './sport';
import { SportService }                     from './sport.service';



@Injectable()
export class SportResolve implements Resolve<Sport[]> {

	constructor(private service: SportService) {}

	resolve() {
		return this.service.getSports();
	}

}


// WEBPACK FOOTER //
// ./src/app/services/sport/sports.resolve.ts